// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 0,
  pageSize: 20,
  customFilters: [],
  value: "",
  sorting: [],
  sortField: "nom",
  sortOrder: "asc",
  activeTab: "details",
  //Nouveau
  query: "",
  actif: {},
  selectedOptionFilters: null,
  selectedOptionId: null,
  column: [],
};

const FiltreProjets = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_PROJET:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_PROJET:
      return {
        ...state,
        currentPage: action.payload,
      };
    case actionTypes.SET_CUSTOM_FILTERS_PROJET:
      return {
        ...state,
        customFilters: action.payload,
      };
    case actionTypes.SET_SORT_FIELD_PROJET:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_PAGE_SIZE_PROJET:
      return {
        ...state,
        pageSize: action.payload,
      };
    case actionTypes.SET_SORTING_PROJET:
      return {
        ...state,
        sorting: action.payload,
      };
    case actionTypes.SET_ORDER_PROJET:
      return {
        ...state,
        sortOrder: action.payload,
      };
    case actionTypes.SET_ACTIVE_TAB_PROJET:
      return {
        ...state,
        activeTab: action.payload,
      };
    case actionTypes.SET_QUERY_PROJET:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.SET_ACTIF_PROJET:
      return {
        ...state,
        actif: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_FILTERS_PROJET:
      return {
        ...state,
        selectedOptionFilters: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_ID_PROJET:
      return {
        ...state,
        selectedOptionId: action.payload,
      };
    case actionTypes.SET_COLUMN_PROJET:
      return {
        ...state,
        column: action.payload,
      };
    default:
      return state;
  }
};

export default FiltreProjets;
